var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2061 32.7536C45.2061 39.6229 39.6375 45.2061 32.7682 45.2061H17.261C10.3917 45.2061 4.80855 39.6375 4.80855 32.7536V17.2464C4.80855 10.3771 10.3771 4.79392 17.261 4.79392H32.7682C39.6375 4.79392 45.2061 10.3625 45.2061 17.2464V32.7536ZM34.5951 0H15.4049C6.89858 0 0 6.89857 0 15.4049V34.5951C0 43.1014 6.89858 50 15.4049 50H34.5951C43.1014 50 50 43.1014 50 34.5951V15.4049C50 6.89857 43.116 0 34.5951 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6797 33.0021C21.295 33.0021 17.758 29.4505 17.758 25.0804C17.758 20.6957 21.3096 17.1587 25.6797 17.1587C30.0497 17.1587 33.6013 20.7103 33.6013 25.0804C33.6013 29.4505 30.0497 33.0021 25.6797 33.0021ZM25.6797 11.9117C18.4011 11.9117 12.511 17.8018 12.511 25.0804C12.511 32.3444 18.4011 38.2491 25.6797 38.2491C32.9582 38.2491 38.8483 32.3444 38.8483 25.0804C38.8483 17.8018 32.9436 11.9117 25.6797 11.9117Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2891 11.7071C41.2891 13.5633 39.7837 15.0541 37.9421 15.0541C36.086 15.0541 34.5952 13.5486 34.5952 11.7071C34.5952 9.86552 36.1006 8.36011 37.9421 8.36011C39.7837 8.36011 41.2891 9.86552 41.2891 11.7071Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.529733a2793289b9e287952d937dfa84.svg";
export { ForwardRef as ReactComponent };